import { Plugin, TextSelection } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';
import { isNodeSelection } from 'prosemirror-utils';
import { findSelectedListNode } from '@intercom/embercom-prosemirror-composer/lib/helpers/selection';
export default class SelectedNodeDecorationPlugin extends Plugin {
  constructor() {
    super({
      state: {
        init: () => ({
          clickOnSection: false
        }),
        apply(tr, value, _oldState, _newState) {
          let data = tr.getMeta(this);
          if (data) {
            return data;
          }
          return value;
        }
      },
      props: {
        //Checks if a section is clicked
        handleClickOn(view, pos, _node, _nodePos, event, _direct) {
          if (event.target?.classList.contains('embercom-prosemirror-composer-section')) {
            let tr = view.state.tr;
            tr.setMeta(this, {
              clickOnSection: true
            });
            tr.setSelection(TextSelection.create(tr.doc, pos));
            view.dispatch(tr);
          } else {
            view.dispatch(view.state.tr.setMeta(this, {
              clickOnSection: false
            }));
          }
          return false;
        },
        decorations(state) {
          if (this.getState(state).clickOnSection) {
            return;
          }
          let from;
          let to;

          // Check if we are in a list
          let parentNode = findSelectedListNode(state);
          if (parentNode) {
            let resolved = state.doc.resolve(parentNode.start);
            from = resolved.before();
            to = resolved.after();
          } else if (isNodeSelection(state.selection)) {
            // Check if we have a node selection, e.g. a button
            from = state.selection.from;
            to = state.selection.to;
          } else {
            let resolved = state.doc.resolve(state.selection.from);
            if (resolved.depth === 0) {
              return;
            }
            if (resolved.nodeAfter?.attrs.type === 'table') {
              // Selecting a table
              from = resolved.pos;
              to = resolved.pos + resolved.nodeAfter.nodeSize;
            } else {
              // Otherwise just resolve from the selection from.
              from = resolved.before();
              to = resolved.after();
            }
          }
          let decoration = Decoration.node(from, to, {
            class: 'embercom-prosemirror-composer-block-selected'
          });
          let decorationSet = DecorationSet.create(state.doc, [decoration]);
          return decorationSet;
        }
      }
    });
  }
}